module.exports = __webpack_public_path__ + "img/project-edu-09.673ba5d3.png";